import React from "react";
import { SimpleGrid } from '@chakra-ui/react';
import DiaryCard from './DiaryCard';

const DiaryList = ({ diaries }) => {
  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
      {diaries.map((diary) => (
        <DiaryCard key={diary.id} diary={diary} />
      ))}
    </SimpleGrid>
  );
};

export default DiaryList;